const getAppFirstReload = () => {
	const appFirstReload = sessionStorage.getItem("appFirstReload")
	return appFirstReload
}

const setAppFirstReload = (value) => {
	sessionStorage.setItem("appFirstReload", value)
}
const removeAppFirstReload = () => {
	sessionStorage.removeItem("appFirstReload")
}

export {
	getAppFirstReload,
	setAppFirstReload,
	removeAppFirstReload,
}